import { Component } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  template: `
    <p-toast position="top-center"></p-toast>
    <p-confirmDialog></p-confirmDialog>
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class AppComponent {
  constructor(private config: PrimeNGConfig) {
    // České hlášky prázdného stavu pro všechny dropdowny/multiselecty/tabulky (jinak PrimeNG
    // ukazuje anglické „No results found"). setTranslation se slučuje se stávajícím překladem.
    this.config.setTranslation({
      emptyFilterMessage: 'Nic nenalezeno',
      emptyMessage: 'Žádné položky',
      emptySearchMessage: 'Nic nenalezeno'
    });
  }
}
